import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DelayHeader } from 'src/app/Interfaces/hr/delay-header';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { CheckValidation } from 'src/app/shared/services/hr/CheckValidation.service';
import { EmployeeService } from 'src/app/shared/services/hr/employee.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { publicSettingService } from '../../../../shared/services/hr/publicSetting';
import { TranslateService } from '@ngx-translate/core';
import { SuperComponent } from 'src/app/pages/super/super.component';
import { DataShareService } from 'src/app/shared/services/data-share.service';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-add-edit-delay-rule-header-system',
  templateUrl: './add-edit-delay-rule-header-system.component.html',
  styleUrls: ['./add-edit-delay-rule-header-system.component.scss']
})
export class AddEditDelayRuleHeaderSystemComponent extends SuperComponent implements OnInit {
  ServerError$: Observable<any> = this.DataShareService.ServerError$;
  Delayname: string = '';
  Delayheaderid: number;
  typeDropDown: any = []
  durationType:{}[]=[]
  DelayData: DelayHeader[] = []
  dataSource: any = [];
  constructor(public _publicSettingService: publicSettingService, translate:TranslateService,  gt: genericCustomStoreService,public route:ActivatedRoute,
     Objects: ObjectsService, private validation: CheckValidation, public router: Router, public _EmployeeService: EmployeeService
     ,public DataShareService: DataShareService) {
      super(Objects,translate,gt)
    this.validateAsync = this.validateAsync.bind(this);
   

      //get dropdown
      this.gt.getdropdowndata("DelayRule/GetDropDown","MinuteRulesTypes").subscribe((data: {}[]) => {this.typeDropDown = data})
      this.gt.getdropdowndata("DelayRule/GetDropDown","RuleDuration").subscribe((data: {}[]) => {this.durationType = data})

    //update
    this._publicSettingService.$ACTIVE_ID.subscribe(res => this.Delayheaderid = res)
    if (this.Delayheaderid != 0) {
      this.loading=true;
      _publicSettingService.byKey("DelayRuleHeaderSystem", this.Delayheaderid).subscribe((res: DelayHeader) => {
        this.dataSource = res.delayRules
        this.Delayname = res.nameAr
        this.loading=false;
      })
    }
    else{
      gt.getdropdowndata("DelayRuleHeaderSystem","GetEmptyRecord").subscribe((res:{delayRules:{}[]})=>this.dataSource=res.delayRules)
    }
  }

  ngOnInit(): void { 
    this.DataShareService.removeServerError()
  }

  validateAsync(params: any) {
    var id = this.Delayheaderid;
    return this.validation.asyncCheckNameValue(params.value, id, "DelayRuleHeaderSystem");

  }
  onFormSubmit(e: any) {
    this.DelayData = [
      {
        id: this.Delayheaderid,
        nameAr: this.Delayname,
        delayRules: this.dataSource
      }
    ]
    if (this.Delayheaderid != 0) {
      this._publicSettingService.update("DelayRuleHeaderSystem", this.DelayData[0]).subscribe(res => {
        this._publicSettingService.$ACTIVE_ReFRESH.next(true)
        this.router.navigate(['hr/DelayHeaderWorkSystem'])
      })

    }
    else {
      this._publicSettingService.add("DelayRuleHeaderSystem", this.DelayData[0]).subscribe(res => {
        this._publicSettingService.$ACTIVE_ReFRESH.next(true)
        this.router.navigate(['hr/DelayHeaderWorkSystem'])
      })

    }
  }
  // backToMainPage(e:string){
  //   if(e=='back'){
  //     this.router.navigate(['/hr/DelayHeaderWorkSystem'])
  //   }
  // }
}
